import { useAtomValue } from 'jotai'

import { StandardLayout } from '@sequencehq/core-components'

import { isSavePendingAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { useCloseInvoiceEditor } from 'Invoices/hooks/useCloseInvoiceEditor'
import { lineItemEditorConfig } from '../SectionLineItems/atoms'

export const ButtonClose = () => {
  const isSavePending = useAtomValue(isSavePendingAtom)
  const lineItemEditorState = useAtomValue(lineItemEditorConfig)
  const closeInvoiceEditor = useCloseInvoiceEditor()

  // Disable escape key shortcut when line item editor is open
  const isLineItemEditorOpen = !!lineItemEditorState

  return (
    <StandardLayout.ButtonClose
      onClick={closeInvoiceEditor}
      disabled={isSavePending}
      disableEscapeShortcut={isLineItemEditorOpen}
      data-testid="header.button.close"
    />
  )
}
